import React from 'react';
import { Accordion } from './Accordion';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve si no sé nada de finanzas?',
    a: 'Sí. El sistema empieza desde cero absoluto. El Tomo 1 asume que nunca invertiste un peso en tu vida.'
  }, {
    q: '¿Está adaptado a la economía argentina?',
    a: '100%. Todo basado en el contexto argentino 2026 — inflación, CEDEARs, plazo fijo UVA, dólar MEP. No es material genérico ni traducido.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Acceso inmediato después del pago. Digital — celular, tablet o computadora. 14 PDFs listos para descargar.'
  }, {
    q: '¿Qué diferencia hay entre los dos planes?',
    a: 'La Guía Esencial tiene los 6 tomos base y los 6 bonos — ideal para ordenar tus finanzas desde cero. El Plan Profesional agrega 2 tomos exclusivos: segundo ingreso y plan a 5 años.'
  }, {
    q: '¿Sirve si gano poco o tengo ingresos irregulares?',
    a: 'Es exactamente para eso. El Tomo 2 tiene una adaptación específica para sueldos irregulares y el sistema funciona con cualquier nivel de ingreso.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días, sin preguntas. Te devolvemos el 100%. Menos del 1% pide devolución.'
  }];
  return <section className="bg-light text-navy py-16 px-4" data-id="element-75">
      <div className="max-w-[720px] mx-auto" data-id="element-76">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 leading-tight" data-id="element-77">
          Lo que más nos preguntan
        </h2>

        <div className="flex flex-col gap-3" data-id="element-78">
          {faqs.map((faq, index) => <Accordion key={index} className="!bg-white !border-navy/10 shadow-sm" headerClassName="hover:!bg-navy/5" title={<span className="font-bold text-[15px] text-navy" data-id="element-80">{faq.q}</span>} data-id="element-79">
              <p className="text-[14px] text-navy/80 leading-[1.6]" data-id="element-81">{faq.a}</p>
            </Accordion>)}
        </div>
      </div>
    </section>;
}